<div class="modal-legal-workspace p-3 bg-white" style="border-radius: 12px; overflow: hidden;">
  
  <div class="modal-legal-header border-bottom pb-2 mb-3">
    <!-- 🚀 TÍTULO ADAPTATIVO: Cambia inteligentemente según la rampa del Workflow -->
    <h3 class="h5 fw-bold text-dark m-0" *ngIf="etapaFirma === 'RECEPCION'">Formalización de Orden de Servicio (Entrada)</h3>
    <h3 class="h5 fw-bold text-dark m-0" *ngIf="etapaFirma === 'COTIZACION'">Formalización y Aceptación de Presupuesto Comercial</h3>
    <h3 class="h5 fw-bold text-dark m-0" *ngIf="etapaFirma === 'ENTREGA'">📜 Acta de Entrega de Unidad y Liberación de Responsabilidad (Salida)</h3>
    
    <span class="small text-muted font-monospace">Folio Activo: {{ folioRecepcion }} | Código Cliente AN8: {{ an8Cliente }}</span>
  </div>

  <!-- Caja de Texto Legal con Scroll Obligatorio (PROFECO / UDC) -->
  <div class="clausulas-scroll-box border rounded bg-light p-3 mb-3" style="max-height: 220px; overflow-y: auto; font-size: 0.82rem; text-align: justify;">
    <h6 class="fw-bold text-secondary mb-2" style="font-size: 0.88rem; text-transform: uppercase;">
      CONTRATO DE ADHESIÓN DE SERVICIOS AUTOMOTRICES - ETAPA {{ etapaFirma }}
    </h6>
    
    <!-- 🚀 Consumo reactivo de tu Signal clausulas() -->
    @for (clausula of clausulas(); track $index) {
      <p class="mb-2"><strong>{{ $index + 1 }}.</strong> {{ clausula }}</p>
    } @empty {
      <p class="text-muted text-center py-2 font-monospace small">⏳ Generando matriz de cláusulas contractuales del taller...</p>
    }
  </div>

  <!-- Checkbox Obligatorio de Consentimiento Legal -->
  <div class="form-check mb-3">
    <input class="form-check-input" type="checkbox" id="checkTerminos" [checked]="terminosAceptados()" (change)="toggleTerminos()" [disabled]="procesandoEnvio()">
    <label class="form-check-label fw-bold text-dark small" for="checkTerminos" style="cursor: pointer; user-select: none;">
      He leído, comprendo y acepto los términos descritos en el clausulado, validando el inventario de pertenencias y autorizando las reparaciones para este hito.
    </label>
  </div>

  <!-- Espacio de Trabajo de Rúbricas Táctiles Duales -->
  <div class="row g-3 structures-firmas" [style.opacity]="terminosAceptados() ? '1' : '0.4'" [style.pointer-events]="terminosAceptados() ? 'auto' : 'none'">
    
    <!-- Canvas 1: Rúbrica del Cliente -->
    <div class="col-md-6">
      <div class="card p-2 border shadow-sm bg-white text-center">
        <span class="d-block text-start small fw-bold text-secondary mb-1">✍️ Firma de Conformidad Cliente:</span>
        <canvas #canvasCliente width="380" height="150" class="border rounded bg-light d-block mx-auto" style="border-style: dashed !important; touch-action: none; background-color: #ffffff;"></canvas>
        <button type="button" class="btn btn-sm btn-link text-danger fw-bold text-decoration-none p-0 mt-1" (click)="limpiarLienzoFisico('CLIENTE')" [disabled]="procesandoEnvio()">
          🗑️ Borrar Trazo
        </button>
      </div>
    </div>

    <!-- Canvas 2: Rúbrica del Asesor -->
    <div class="col-md-6">
      <div class="card p-2 border shadow-sm bg-white text-center">
        <span class="d-block text-start small fw-bold text-secondary mb-1">👨‍🔧 Firma de Validación Asesor:</span>
        <canvas #canvasAsesor width="380" height="150" class="border rounded bg-light d-block mx-auto" style="border-style: dashed !important; touch-action: none; background-color: #ffffff;"></canvas>
        <button type="button" class="btn btn-sm btn-link text-danger fw-bold text-decoration-none p-0 mt-1" (click)="limpiarLienzoFisico('ASESOR')" [disabled]="procesandoEnvio()">
          🗑️ Borrar Trazo
        </button>
      </div>
    </div>

  </div>

  <!-- Acciones Finales de Cierre -->
  <div class="text-end mt-4 border-top pt-3">
    <button type="button" class="btn btn-sm btn-secondary me-2 fw-bold px-3" (click)="cerrarModal()" [disabled]="procesandoEnvio()">
      Cancelar
    </button>
    <button type="button" class="btn btn-sm btn-success fw-bold px-4 shadow-sm" [disabled]="!terminosAceptados() || procesandoEnvio()" (click)="procesarYEnviarFirmas()">
      {{ procesandoEnvio() ? '💾 Guardando en Red...' : '📜 Confirmar Autorización Legal' }}
    </button>
  </div>

</div>